import { useProcurifyIntl } from '@webapp/hooks'
import { type IConversationOrderSummaryItem } from './ConversationOrderSummary'
import messages from './messages'
import { ConversationOrderSummaryQuantityCounterStyled } from './styles/ConversationOrderSummaryQuantityCounterStyled'

export interface IConversationOrderSummaryStepperProps {
  item: IConversationOrderSummaryItem
  disabled?: boolean
  isRemoveDisabled?: boolean
  onIncrement: (itemId: string) => void
  onDecrement: (itemId: string) => void
  onRemove: (itemId: string) => void
}

export const ConversationOrderSummaryStepper = ({
  item,
  disabled,
  isRemoveDisabled,
  onIncrement,
  onDecrement,
  onRemove,
}: IConversationOrderSummaryStepperProps) => {
  const intl = useProcurifyIntl()

  const handleChange = (newValue: number) => {
    if (newValue > item.quantity) {
      onIncrement(item.id)
    } else {
      onDecrement(item.id)
    }
  }

  const handleDelete = () => {
    onRemove(item.id)
  }

  return (
    <ConversationOrderSummaryQuantityCounterStyled
      value={item.quantity}
      disabled={disabled}
      isRemoveDisabled={isRemoveDisabled}
      onChange={handleChange}
      onDelete={handleDelete}
      removeButtonAriaLabel={intl.formatMessage(messages.removeItemAriaLabel, {
        name: item.name,
      })}
      decreaseButtonAriaLabel={intl.formatMessage(
        messages.decreaseQuantityAriaLabel,
        { name: item.name }
      )}
      increaseButtonAriaLabel={intl.formatMessage(
        messages.increaseQuantityAriaLabel,
        { name: item.name }
      )}
    />
  )
}
